import { Button } from "antd";
import { getSupaClient } from "../../lib/supabase";
import { useState } from "react";
import useStripeCustomers from "./useStripeCustomers";
import DotsFishLoading from "../DotsFishLoading/DotsFishLoading";
import dayjs from "dayjs";

const CurrentIndicator = () => {
  return (
    <div className="flex justify-center">
      <div className="mb-3 text-xs shrink-0 items-center font-bold leading-sm uppercase px-3 py-1 bg-green-200 text-green-700 rounded-lg">
        Current plan
      </div>
    </div>
  );
};

export default function Billing() {
  const [loading, setLoading] = useState<boolean>(false);
  const [customerId, setCustomerId] = useState<String | null>(null);
  const guildId = localStorage.getItem("guild-id");
  const { isLoading, billingCustomer } = useStripeCustomers(guildId);
  console.log("in billing");
  async function getStripeCheckoutUrl(customerId: string, priceId: string) {
    const supabase = getSupaClient();
    const session = supabase.auth.session();
    const response = await fetch(
      `${process.env["REACT_APP_API_URL"]}/billing/checkoutsession`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${session?.access_token}` },
        body: JSON.stringify({
          customerId: customerId,
          product: priceId,
          mode: "subscription",
        }),
      }
    );

    if (response.ok) {
      const responseJson = await response.json();
      window.location = responseJson.sessionUrl;
    } else {
      console.log("Error getting a checkout url");
    }
  }

  // portal url to manage billing
  async function loadStripePortalUrl(customerId: string) {
    setLoading(true);
    const supabase = getSupaClient();
    const session = await supabase.auth.session();
    const response = await fetch(
      `${process.env["REACT_APP_API_URL"]}/billing/portal`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${session?.access_token}` },
        body: JSON.stringify({ customerId: customerId }),
      }
    );

    if (response.ok) {
      const responseJson = await response.json();

      window.location = responseJson.sessionUrl;
      setLoading(false);
    } else {
      console.log("Error getting a portal URL");
      setLoading(false);
    }
  }
  if (!billingCustomer) {
    return <DotsFishLoading />;
  }

  const PricingCard = () => {
    return (
      <section>
        <div className="py-4 mx-auto">
          <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
            <div className="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
              {billingCustomer.tier == "free" ? <CurrentIndicator /> : null}
              <h3 className="mb-4 text-2xl font-semibold">Free</h3>
              <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                For hobbyist communities that want to grow
              </p>
              <div className="flex justify-center items-baseline my-8">
                <span className="mr-2 text-5xl font-extrabold">$0</span>
                <span className="text-gray-500 dark:text-gray-400">/month</span>
              </div>

              {/* <ul role="list" className="mb-8 space-y-4 text-left">
      <li className="flex items-center space-x-3">
        <CheckOutlined />
        <span>Individual configuration</span>
      </li>
    </ul> */}
              {billingCustomer.tier != "free" ? (
                <Button
                  loading={loading}
                  type="default"
                  onClick={() =>
                    loadStripePortalUrl(billingCustomer?.stripe_id)
                  }
                  className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900"
                >
                  Downgrade
                </Button>
              ) : null}
            </div>
            {/* Pro plan */}
            <div className="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
              {billingCustomer.tier == "pro" ? <CurrentIndicator /> : null}
              <h3 className="mb-4 text-2xl font-semibold">Pro</h3>
              <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                For communities that want to actively invest in engaging
              </p>
              <div className="flex justify-center items-baseline my-8">
                <span className="mr-2 text-5xl font-extrabold">$29</span>
                <span className="text-gray-500 dark:text-gray-400">/month</span>
              </div>

              {billingCustomer.tier != "pro" ? (
                <Button
                  loading={loading}
                  type={
                    billingCustomer.tier == "business" ? "default" : "primary"
                  }
                  onClick={() =>
                    loadStripePortalUrl(billingCustomer?.stripe_id)
                  }
                  className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900"
                >
                  {billingCustomer.tier == "business" ? "Downgrade" : "Upgrade"}
                </Button>
              ) : null}
            </div>
            {/* Business plan */}
            <div className="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
              {billingCustomer.tier == "business" ? <CurrentIndicator /> : null}
              <h3 className="mb-4 text-2xl font-semibold">Business</h3>
              <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
                For businesses that require insights, and premium steps
              </p>
              <div className="flex justify-center items-baseline my-8">
                <span>from</span>
                <span className="ml-2 mr-2 text-5xl font-extrabold">$99</span>
                <span className="text-gray-500 dark:text-gray-400">/month</span>
              </div>
              {billingCustomer.tier != "business" ? (
                <Button
                  loading={loading}
                  type="primary"
                  onClick={() =>
                    loadStripePortalUrl(billingCustomer?.stripe_id)
                  }
                  className="text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white  dark:focus:ring-primary-900"
                >
                  Upgrade
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );
  };

  return (
    <div>
      <div className="ml-1">
        <p className="mb-3 text-gray-500 text-lg">
          {/**Show a trial message if trial end is post current data. otherwise show the current plan */}
          {billingCustomer.trial_end > dayjs().toISOString()
            ? `Trialling  ${billingCustomer.trial_tier} plan (ends in ${dayjs(
                billingCustomer.trial_end
              ).diff(new Date(), "day")} days)`
            : `Currently on ${billingCustomer.tier} plan - ${billingCustomer.status}`}
        </p>

        <div>
          <Button
            loading={loading}
            type="primary"
            onClick={() => loadStripePortalUrl(billingCustomer?.stripe_id)}
          >
            Upgrade Plan / Manage Billing
          </Button>
          {/* <Button
            loading={loading}
            type="primary"
            onClick={() =>
              getStripeCheckoutUrl(
                billingCustomer?.stripe_id,
                process.env["REACT_APP_STRIPE_PRICE_PRO"] as string
              )
            }
          >
            Upgrade
          </Button> */}
        </div>
      </div>
      <div>{/* <PricingCard /> */}</div>
    </div>
  );
}
